<template>
  <div class="background">
    <!-- <div class="background" :style="{backgroundImage: image}"></div> -->
    <!-- <div id="overlay" v-if="videoOverlayVisible">
      <video id="fullscreenVideo" style="width:100%" autoplay>
        <source :src="infoVideoPath" type="video/mp4" />
      </video>
    </div>-->
    <div style="height: 100%" v-if="imageOverlayVisible">
      <img height="100%" :src="infoImagePath" />
    </div>
    <div style="height: 100%" v-else>
      <img height="100%" :src="image" />
    </div>
    <div id="overlayBottomRight" style="z-index: 100">
      <img
        src="@/assets/ZURUECK.png"
        style="width: 7%"
        alt="Back Button"
        @click="backClicked()"
      />
    </div>
    <div id="overlayBottomRightInfo" style="z-index: 100" v-if="infoImagePath">
      <img
        src="@/assets/button-information.png"
        style="width: 3%"
        alt="Back Button"
        @click="showInfoImage()"
      />
    </div>
    <div id="overlayBottomRightVideo" style="z-index: 100" v-if="infoVideoPage">
      <img
        src="@/assets/button-video_kamera.png"
        style="width: 3%"
        alt="Back Button"
        @click="showInfoVideo()"
      />
    </div>
  </div>
</template>

<script>
import { productSettings } from "../ProductSettings";

export default {
  name: "Product",
  data() {
    return {
      image: productSettings[this.$route.params.page].productImage,
      //   info: productSettings[this.$route.params.page].info,
      backDestinationName:
        productSettings[this.$route.params.page].backDestinationName,
      backDestinationParam:
        productSettings[this.$route.params.page].backDestinationParam,

      // infoVideoPath: productSettings[this.$route.params.page].infoVideo,
      // videoOverlayVisible: false,
      infoVideoPage: productSettings[this.$route.params.page].videoPage,

      infoImagePath: productSettings[this.$route.params.page].infoImage,
      imageOverlayVisible: false,
    };
  },
  computed: {
    infoExists() {
      return this.infoVideoPath || this.infoImagePath;
    },
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: this.backDestinationName,
        params: { page: this.backDestinationParam },
      });
    },
    showInfoImage() {
      this.imageOverlayVisible = !this.imageOverlayVisible;
    },
    showInfoVideo() {
      // this.videoOverlayVisible = !this.videoOverlayVisible;
      this.$router.push({
        name: "videostartpage",
        params: { page: this.infoVideoPage },
      });
    },
  },
  created() {
    if (
      !this.image.startsWith("https://") &&
      !this.image.startsWith("http://")
    ) {
      this.image = "https://my.lrinfomanager.com/" + this.image;
    }

    if (
      this.infoVideoPath &&
      !this.infoVideoPath.startsWith("https://") &&
      !this.infoVideoPath.startsWith("http://")
    ) {
      this.infoVideoPath = "https://my.lrinfomanager.com/" + this.infoVideoPath;
    }

    if (
      this.infoImagePath &&
      !this.infoImagePath.startsWith("https://") &&
      !this.infoImagePath.startsWith("http://")
    ) {
      this.infoImagePath = "https://my.lrinfomanager.com/" + this.infoImagePath;
    }
  },
};
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  background-size: contain;
}

#overlayBottomRight {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 1000;
}

#overlayBottomRightInfo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 90%;
  /* padding: 30px; */
  text-align: right;
}

#overlayBottomRightVideo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 86%;
  /* padding: 30px; */
  text-align: right;
}
</style>